import { Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { I18nNamespace } from '~/common/types';
import { ConversationStarterActions } from '~/components/ConversationQuickAction/components/ConversationStarterActions/ConversationStarterActions';
import { useUser } from '~/hooks/useUser/useUser';

interface EmptyConversationProps {
  entity: string;
  showQuickActions: boolean;
}
export const EmptyConversation = ({ entity, showQuickActions }: EmptyConversationProps) => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'EmptyState' });
  const { user } = useAuth();
  const { profile } = useUser({
    userId: user?.profile.user_id as string,
  });
  const { firstName, lastName } = profile || {};
  return (
    <Stack alignItems="center" textAlign="center">
      <Typography variant="h6">{t('title', { firstName, lastName })}</Typography>
      <Typography variant="body1">
        <Trans t={t} i18nKey="description" values={{ entity }} />
      </Typography>
      <ConversationStarterActions showQuickActions={showQuickActions} />
    </Stack>
  );
};
